import axios from 'axios';
import config from '../config';

const API_BASE_URL = `${config.API_BASE_URL}/auth/user`;

export const userService = {
  async deleteAccount(): Promise<{ message: string }> {
    const response = await axios.delete(`${API_BASE_URL}/delete-account`);
    return response.data;
  }
};
